// extracted by mini-css-extract-plugin
export var main = "_1-1";
export var shell = "_1-0";